module.exports = __webpack_public_path__ + "static/media/gw.c4153cf3.jpeg";